export default () => ({
  nav: [
    { target: '/l/wein-des-monats', name: 'Wein des Monats' },
    { target: '/l/veranstaltungen', name: 'Veranstaltungen' },
    { target: '/l/willkommen', name: 'Über uns' },
  ],
})
